export default __webpack_public_path__ + "static/media/d21.073bcaea.jpg";